import React from 'react';

export const CLI_INFO = {
    header: <h2>CLI</h2>,
    body: (
        <>
            <p>
                To use this project with your CLI, add it using the
                <a href={'https://dstack.ai/docs/reference/cli/dstack/project/'} target="_blank">
                    <code>dstack project add</code>
                </a>{' '}
                command.
            </p>
            <p>
                To learn how to install the CLI, refer to the{' '}
                <a href={'https://dstack.ai/docs/cli/installation'} target="_blank">
                    installation
                </a>{' '}
                guide.
            </p>
        </>
    ),
};
